export default __webpack_public_path__ + "static/media/calendar.40eb65ee.svg";